module.exports = __webpack_public_path__ + "static/media/IMG-32.69b0a114.jpg";